import { Box, Typography } from "@mui/material";
import { StyledNavbar } from "./Navbar.styled";
import logo from "../../Images/A-Logo.png";
import { useNavigate } from "react-router-dom";
import { useNavbar } from "../../Hooks/useNavbar";
import { ListIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { XIcon } from "@phosphor-icons/react/dist/ssr";

export const Navbar = () => {
  const navigate = useNavigate();
  const { Navlinks } = useNavbar();
  const [navbarExtended, setNavbarExtended] = useState<boolean>(false);

  return (
    <StyledNavbar>
      <Box className="logoWrapper">
        <img src={logo} alt="Bijnensart Logo" />
      </Box>
      <Box className="menuIcon mobile">
        {navbarExtended ? (
          <XIcon size={40} weight="bold" onClick={() => {setNavbarExtended(false)}}/>
        ) : (
          <ListIcon size={40} weight="bold" onClick={() => {setNavbarExtended(true)}}/>
        )}
      </Box>
      <Box className={`navlinks ${navbarExtended && "navLinksExtended"}`}>
        {Navlinks.map((navlink) => (
          <Typography variant="h6" onClick={() => navigate(navlink.path)}>
            {navlink.title}
          </Typography>
        ))}
      </Box>
    </StyledNavbar>
  );
};
